// extracted by mini-css-extract-plugin
export default {"color":"DomainForm_color__GWh7K","colorInput":"DomainForm_colorInput__ia5lv","colorLabel":"DomainForm_colorLabel__xl-BD"};